import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from 'uuid';
import { FxButtonBase } from "../../fxms/inputs/FxButton";
import { FxLabelBase } from "../../fxms/inputs/FxLabel";
import { FxmsData } from "../../fxms/datas/FxData";
import { FxWindow } from "../../fxms/windows/FxWindows";
import { FxActionBase } from "../../fxms/actions/FxAction";
import { FxTextFieldBase } from "../../fxms/inputs/FxTextField";
import { FxTextAreaBase } from "../../fxms/inputs/FxTextArea";
import { FxSelectQnaMenuClCd} from "../inputs/VupInputs";
import { FxFileLink } from "../../fxms/inputs/FxFileLink";
import { FxProgressBar} from "../components/FxProgressBar";
import axios from "axios";

/*마이페이지> 1:1문의 등록 화면 */
export const UI_8_1_CU = (props) => {
  const {attr, onCloseBtnClick} = props;
  const [inputDatas, setInputDatas] = React.useState({
    qnaTitle : "",
    qnaCnts: "",
    qnaEmail: ""
  });
  const [selectedData, setSelectedData] = React.useState({});
  const [editableYn, setEditableYn] = React.useState(
    props.name ==="ui-8-1-detail"? true : false );
  
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadedSize, setUploadedSize] = useState(0);
  const [fileUploadYn, setFileUploadYn] = useState('N');
  const [uploadedFileKey, setUploadedFileKey] = useState([]);
  const [selectedUploadedFiles, setSelectedUploadedFiles] = useState([]);
  
  const refershGridData = props.refershGridData? props.refershGridData: attr.callback;

  useEffect(() => {    

    console.log("UI_8_1_CU", props); 

   if(editableYn){
    setSelectedUploadedFiles(props.selectedData.files);
    setSelectedData(props.selectedData);
    setInputDatas(props.selectedData)
    setUploadedFiles(props.selectedData.files)
   }    

  }, [selectedFiles]);

  function onChangeValue(id, value) {
    let newData = { ...inputDatas };

    if (value) {
      newData[id] = value;
    } else {
      delete newData[id];
    }
    setInputDatas(newData);
  }
  

  const onRegister = async() => { 
    /*문의분류 제목 필수 체크 추가해야함 */  
      
      if(uploadedFileKey.length!==0) inputDatas.fileKeys = uploadedFileKey;

       if(selectedFiles.length !==0 && fileUploadYn==='N') {
        FxWindow.alert("파일업로드를 해주세요", true) 
        return ;      
      } 
      
      if(!validation(inputDatas)) return;
        
       // 추가
        let caller = new FxActionBase("vup/add_8_1", "POST");
        caller.execute(inputDatas, function (bret) { //FxActionBase 참초
          console.log("UI_8_1_CU regist result ", bret);
          onCloseBtnClick();                    
          refershGridData();
        });        
  }

const onUpdate = () => { 
    setEditableYn(false);
  }
  
const onDelete = (item) => {
  console.log(item)

  const files = Array.from(selectedFiles).filter((f) => f !== item)

  setUploadedSize(uploadedSize-item.size);

  setSelectedFiles(files);

}

 const onFileUpload = async (e) => {
  
    if(selectedFiles.length===0) {
      FxWindow.alert("선택한 파일이 없습니다.", true);
      return;
    }

    const formData = new FormData();

    for (let i = 0; i < selectedFiles.length; i++) {
      formData.append('files', selectedFiles[i]);
    }

    console.log(Array.from(formData));

    let dataSet = {
      url: "8_1",
      delYn: "N"
    };

    const json = JSON.stringify(dataSet);
    const blob = new Blob([json], { type: "application/json" });
    formData.append("data", blob);

    await axios({
      method: "POST",
      url: "/api/open/upload",
      mode: "cors",
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      data: formData,
    }).then((res)=>{      
      setFileUploadYn('Y');             
      setUploadedFiles([...uploadedFiles, ...Array.from(selectedFiles)])
      setSelectedFiles([]);
      setUploadedFileKey(res.data);
      FxWindow.alert("파일업로드가 완료되었습니다.");
    })    
  };

  const handleFileChange = (e) => {  

    if(e.target.files.length===0) {
      setUploadedSize(0);
      setSelectedFiles([]);
      return;
    }

    const selectedFiles = e.target.files;
    let fileSize = 0;  
    
    for(let file of selectedFiles){
      fileSize += file.size;
    }
  
    const limitsize = 1024 ** 2 * 10; //10MB    
  
    let fileSizeP = ((uploadedSize+fileSize) );

       if (fileSizeP > limitsize) {
      FxWindow.alert("첨부파일의 용량을 확인해주세요", true) 
      return ; 
    }
  
    setUploadedSize(fileSizeP);
   
    setSelectedFiles(selectedFiles);
       
  }

  const validation = (inputDatas) =>{


    if(inputDatas.qnaMenuClCd===undefined) {
       FxWindow.alert("문의분류를 선택해주세요", true) ;
       return false;
    }
    if(inputDatas.qnaTitle==="") {
       FxWindow.alert("제목을 입력해주세요" , true) ;
       return false;
    }
    if(inputDatas.qnaCnts==="") {
       FxWindow.alert("내용을 입력해주세요" , true) ;
       return false;
    }

    if(inputDatas.qnaEmail==="") {
      FxWindow.alert("이메일을 입력해주세요" , true) ;
      return false;
   }

    return true;

  }

  return (
    <div>
      <div className="FxDataEdit">
        <table className="table">
          <colgroup>
            <col style={{ width: '100px' }} />
            <col style={{ width: '600px' }} />
          </colgroup>
          <tr>
            <th><FxLabelBase>문의분류</FxLabelBase></th>
            { editableYn?
             <td> <select disabled={true} className="FxSelectSearch" value={selectedData.qnaMenuClCd}>
             <option value={selectedData.qnaMenuClCd}> {selectedData.qnaMenuClNm} </option>
             </select></td>
             :  <td><FxSelectQnaMenuClCd onChangeValue={onChangeValue} optionText={"문의분류선택"} selectedData={selectedData} name="qnaMenuClCd" width="200px" /></td> 
           }      
          </tr>
          <tr>
            <th><FxLabelBase>문의제목</FxLabelBase></th>
            <td><FxTextFieldBase name="qnaTitle" onChangeValue={onChangeValue} selectedData={selectedData} disabled={editableYn}  />
            </td>
          </tr>
          <tr>
            <th><FxLabelBase>문의내용</FxLabelBase></th>
            <td> 
            <FxTextAreaBase name="qnaCnts" onChangeValue={onChangeValue} selectedData={selectedData} disabled={editableYn} />
            </td>
          </tr>
          <tr>
            <th><FxLabelBase>이메일</FxLabelBase></th>
            <td> <FxTextFieldBase name="qnaEmail" onChangeValue={onChangeValue} selectedData={selectedData} disabled={editableYn} />
           </td>
          </tr>
          {editableYn ?
            <><tr>
              <th><FxLabelBase>첨부</FxLabelBase></th>
              <td>
                {selectedUploadedFiles.map((item)=> (
                     <span key={item.fileId}> <FxFileLink fileId={item.fileId} fileUrl={'8_1'} orgNm={item.name}></FxFileLink> </span>
              ))}
              </td>
            </tr> 
            <tr>
                <th><FxLabelBase>진행상태</FxLabelBase></th>
                <td> <input className="qnaStCd" name="qnaStCd" value={selectedData.qnaStCd||""} disabled={editableYn} style={{ height: '30px' }} /></td>
              </tr>
             {selectedData.qnaStCd==="답변완료"? <tr>
                <th><FxLabelBase>답변내용</FxLabelBase></th>
                <td> <FxTextAreaBase name="qnaAnswCnts" onChangeValue={onChangeValue} selectedData={selectedData} disabled={true} /></td>
              </tr>
               : <></> }   
              </> : <tr>
              <th rowSpan='2'><FxLabelBase>첨부</FxLabelBase></th>
              <td>
                <div className="VupFileUpWrap">
                  <input
                    id="fileUp"
                    className='file-input'
                    type="file"                 
                    onChange={handleFileChange}
                    multiple="multiple"
                    disabled={editableYn}
                  />
                  <div className="fileInput"> </div>
                  <button >파일선택</button>  

                </div>
                <FxProgressBar percent={uploadedSize/ (1024 ** 2  * 10) * 100} baseNum={1024 ** 2 * 10}/> 
                <ul className="VupFileUpList">
                  {Array.from(uploadedFiles).map((item) => (
                    <li className="fin">
                      <span>{item.name}</span>
                    </li>
                  ))}
                  {Array.from(selectedFiles).map((item) => (
                    <li>
                      {item.name}
                      <button onClick={() => onDelete(item)}> </button>
                    </li>
                  ))}
                </ul>
                <ul className="VupFileUpNotice">
                    <li>첨부한 파일의 전체 크기는 10Mbyte 미만이어야 합니다.</li>
                    <li>용량이 초과될 경우, 문의 접수가 원활하게 진행되지 않을 수 있습니다.</li>
                    <li>파일첨부는 JPG, GIF, PSD, TIF, MS Office 파일, 아래한글, PDF만 가능합니다.</li>
                </ul>
              </td>
            </tr>}
        </table>
      </div>
      <div className="FxCrudToolbar">
        <div className="FxFilterLeft">
        </div>
        <div className="FxFilterRight">      
          { selectedData.qnaStCd==="답변완료"? <></>: editableYn? <FxButtonBase key={uuidv4()} name="click" onClick={onUpdate} text="수정" /> : 
          <><FxButtonBase key={uuidv4()} name="click" onClick={onFileUpload} text="파일업로드" /><FxButtonBase key={uuidv4()} name="click" onClick={onRegister} text="등록" /></>}
        </div>
        
      </div>
    </div>
  )
}
